import React from 'react';
export function DashboardShimmer() {
  return <div className="space-y-6 animate-pulse" role="status" aria-busy="true" aria-live="polite" data-id="element-15141">
      <span className="sr-only" data-id="element-15142">Loading dashboard…</span>
      {/* KPI Cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-15143">
        {[1, 2, 3, 4].map(i => <div key={i} className="bg-white rounded-lg border border-gray-200 p-6" data-id="element-15144">
            <div className="flex justify-between items-start mb-4" data-id="element-15145">
              <div className="h-4 w-32 bg-gray-200 rounded" data-id="element-15146" />
              <div className="w-10 h-10 bg-gray-200 rounded-md" data-id="element-15147" />
            </div>
            <div className="h-8 w-40 bg-gray-200 rounded mb-2" data-id="element-15148" />
            <div className="h-3 w-24 bg-gray-200 rounded" data-id="element-15149" />
          </div>)}
      </div>
      {/* Charts Row */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6" data-id="element-15150">
        {[1, 2].map(i => <div key={i} className="bg-white rounded-lg border border-gray-200 p-6" data-id="element-15151">
            <div className="flex justify-between items-center mb-4" data-id="element-15152">
              <div className="h-5 w-32 bg-gray-200 rounded" data-id="element-15153" />
              <div className="h-4 w-24 bg-gray-200 rounded" data-id="element-15154" />
            </div>
            <div className="h-64 bg-gray-200 rounded-md" data-id="element-15155" />
          </div>)}
      </div>
      {/* Activity Section */}
      <div className="bg-white rounded-lg border border-gray-200 p-6" data-id="element-15156">
        <div className="h-5 w-40 bg-gray-200 rounded mb-4" data-id="element-15157" />
        <div className="space-y-3" data-id="element-15158">
          {[1, 2, 3, 4, 5].map(i => <div key={i} className="flex items-center gap-4 p-3 border border-gray-200 rounded-lg" data-id="element-15159">
              <div className="w-10 h-10 bg-gray-200 rounded-full" data-id="element-15160" />
              <div className="flex-1 space-y-2" data-id="element-15161">
                <div className="h-4 w-64 bg-gray-200 rounded" data-id="element-15162" />
                <div className="h-3 w-32 bg-gray-200 rounded" data-id="element-15163" />
              </div>
              <div className="h-4 w-20 bg-gray-200 rounded" data-id="element-15164" />
            </div>)}
        </div>
      </div>
    </div>;
}